import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';

export const authenticatedMatchGuard: CanMatchFn = (route, segments) => {
	const oauthService = inject(OAuthService);
	if (oauthService.hasValidIdToken()) {
		return true;
	}
	oauthService.initLoginFlow();
	return false;
};
